<template>
  <section class="step">
    <Navigation name="contact"></Navigation>

    <div class="step-body">
      <h1>Contact Information</h1>
      <div class="col-2">
        <div class="input-group mb-3"
          :class="[component.fields.email.length > 0 ? (component.validate.email ? 'valid' : 'error') : '']">
          <label class="form-label">Business Email:</label>
          <input type="email" @change="component.validateEmail" v-model.trim="component.fields.email"
            placeholder="info@itt.com.au">
        </div>
        <div class="input-group mb-3"
          :class="[component.fields.name.length > 0 ? (component.validate.name ? 'valid' : 'error') : '']">
          <label class="form-label">Full Name:</label>
          <input type="text" v-model="component.fields.name" @input="component.validateHumanName"
            @change="component.validateEmpty" placeholder="John Smith">
          <span class="hidden"></span>
        </div>
      </div>
      <div class="col-2">
        <div class="input-group mb-3"
          :class="[component.fields.phone.length > 0 ? (component.validate.phone ? 'valid' : 'error') : '']">
          <label class="form-label">Phone or Mobile:</label>
          <input type="tel" @input="component.maskPhone" v-model="component.fields.phone"
            @change="component.validatePhone" placeholder="(02) 4297 0037">
        </div>
        <div class="input-group mb-3"
          :class="[component.fields.state.length > 0 ? (component.validate.state ? 'valid' : 'error') : '']"
          style="flex-grow: 1.1;">
          <label class="form-label">State:</label>
          <select class="form-select" @change="component.validateEmpty" v-model="component.fields.state">
            <option selected>Please select</option>
            <option value="NSW">New South Wales</option>
            <option value="QLD">Queensland</option>
            <option value="SA">South Australia</option>
            <option value="TAS">Tasmania</option>
            <option value="VIC">Victoria</option>
            <option value="WA">Western Australia</option>
          </select>
        </div>
      </div>
      <div class="input-group mb-3"
        :class="[component.fields.address.length > 0 ? (component.validate.address ? 'valid' : 'error') : '']">
        <label class="form-label">Address:</label>
        <textarea v-model="component.fields.address" @change="component.validateEmpty"
          placeholder="22 Wollombi Street, Howes Valley, New South Wales" cols="5" rows="5"></textarea>
        <!-- <span class="error-append"></span> -->
      </div>
      <div id="wizard-action">
        <router-link :to="{ name: 'Company' }" class="prevBtn"> Back</router-link>
        <router-link @click.native="component.send" :to="{ name: 'Thanks' }"
          :class="{ 'nextBtn': true, 'disabled': !component.isEnabled.value }">
          Submit</router-link>
        <!-- <button (click)="showLoader()" [routerLink]="['/my-book-listing']">Submit</button> -->

      </div>
    </div>

  </section>
</template>
<script setup lang="ts">
import Navigation from "../layout/navigation.component.vue";
import component from "./contact.component";
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';

onBeforeRouteLeave(async (to, from) => {
  console.log(to.name, from.name);
  if (to.name?.toString().toLowerCase().includes('Thanks')) {
    component.send();
  }
})
// onBeforeRouteUpdate((to, from, next) => {
//   console.log(to.name, from.name);
//   next();
// })
</script>